import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const MiscellaneousLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(0 0) rotate(-12)"
    >
      <linearGradient
        id="SVGID_19_"
        x1="1209.303"
        x2="1286.501"
        y1="427.045"
        y2="427.045"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="url(#SVGID_19_)"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(87 -15) rotate(-4)"
    >
      <linearGradient
        id="SVGID_19_"
        x1="1209.303"
        x2="1286.501"
        y1="427.045"
        y2="427.045"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="url(#SVGID_19_)"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(190 -25) rotate(14)"
    >
      <linearGradient
        id="SVGID_19_"
        x1="1209.303"
        x2="1286.501"
        y1="427.045"
        y2="427.045"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="url(#SVGID_19_)"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(0 -85) rotate(-5)"
    >
      <linearGradient
        id="SVGID_19_"
        x1="1209.303"
        x2="1286.501"
        y1="427.045"
        y2="427.045"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="url(#SVGID_19_)"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(90 -95) rotate(2)"
    >
      <linearGradient
        id="SVGID_19_"
        x1="1209.303"
        x2="1286.501"
        y1="427.045"
        y2="427.045"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="url(#SVGID_19_)"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(185 -105) rotate(8)"
    >
      <linearGradient
        id="SVGID_19_"
        x1="1209.303"
        x2="1286.501"
        y1="427.045"
        y2="427.045"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="url(#SVGID_19_)"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g
      className="digital-resources-miscellaneous"
      transform="translate(237, 400)"
    >
      <defs>
        <radialGradient
          id="bf5d73cb-97c8-467e-98c0-b824c3393bca"
          data-name="grad-35"
          cx="228"
          cy="304.5"
          r="69"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#00ff78" />
          <stop offset="0.1" stopColor="#00ff7b" stopOpacity="0.98" />
          <stop offset="0.22" stopColor="#00ff84" stopOpacity="0.91" />
          <stop offset="0.36" stopColor="#00ff92" stopOpacity="0.81" />
          <stop offset="0.51" stopColor="#00ffa6" stopOpacity="0.66" />
          <stop offset="0.68" stopColor="#00ffc0" stopOpacity="0.47" />
          <stop offset="0.84" stopColor="#00ffdf" stopOpacity="0.24" />
          <stop offset="1" stopColor="aqua" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="a92a2720-bd9d-49bf-9fc6-d08359e2e19e"
          r="69.5"
          xlinkHref="#bf5d73cb-97c8-467e-98c0-b824c3393bca"
        />
        <radialGradient
          id="b93d8e63-3a65-4a32-b7a0-97e3ab75c2fc"
          data-name="grad-2"
          cx="404.06"
          cy="128.57"
          r="3.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0.3" />
          <stop offset="0.51" stopColor="#7fff7f" stopOpacity="0.65" />
          <stop offset="1" stopColor="lime" />
        </radialGradient>
        <radialGradient
          id="b904d390-402a-44a2-bc7a-726543f63655"
          data-name="grad-3"
          cx="394.56"
          cy="130.08"
          r="2.39"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0.5" />
          <stop offset="0.13" stopColor="#f7d1df" stopOpacity="0.6" />
          <stop offset="0.38" stopColor="#e87fa5" stopOpacity="0.77" />
          <stop offset="0.62" stopColor="#dd447c" stopOpacity="0.9" />
          <stop offset="0.84" stopColor="#d62163" stopOpacity="0.97" />
          <stop offset="1" stopColor="#d4145a" />
        </radialGradient>
        <radialGradient
          id="f5646a17-839a-40d9-accc-d2c771dfc960"
          data-name="grad-70"
          cx="379.56"
          cy="301.41"
          r="20.6"
          gradientTransform="translate(0 -141.86) scale(1 0.87)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.21" stopColor="#93278f" />
          <stop offset="0.35" stopColor="#a0268c" stopOpacity="0.88" />
          <stop offset="0.64" stopColor="#c32283" stopOpacity="0.57" />
          <stop offset="0.95" stopColor="#ed1e79" stopOpacity="0.2" />
        </radialGradient>
        <radialGradient
          id="a8558419-dbb8-4ed0-962d-2eeb95accd20"
          cx="379"
          cy="99.8"
          r="25.35"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlinkHref="#f5646a17-839a-40d9-accc-d2c771dfc960"
        />
      </defs>
      <g id="ea802339-5040-4a9d-89b9-73cb70b8ac87" data-name="misc">
        <g>
          <g>
            <path
              d="M232.71,436v-4A19.16,19.16,0,0,1,232.71,436Z"
              fill="#e7f4f7"
            />
            <path
              d="M292.49,303s-13.48-21.09-14.65-4.1,17.58,59.19-5.86,78.53c0,0,5.86-24.61-7-25.2-11.86-.54-30.66,60.42-32.23,79.76-1.56-19.34-20.37-80.3-32.23-79.76-12.89.59-7,25.2-7,25.2-23.44-19.34-4.69-61.53-5.86-78.53s-14.65,4.1-14.65,4.1c-3.52-28.12,14.65-47.46,14.65-47.46l25.2-.59,8.2,11.14h25.79l8.2-10.55h22.86S296,274.85,292.49,303Z"
              fill="#e7f4f7"
            />
            <path
              d="M287.21,288.32S271,279.63,270,293.68,294.88,338,275.49,354c0,0-5.45-15.68-16.12-16.17-9.81-.44-25.36,50-26.66,66-1.29-16-16.84-66.42-26.66-66-10.66.49-12.6,11.48-12.6,11.48-19.39-16,2.91-41.53,1.94-55.59s-17.18-5.36-17.18-5.36c-2.9-23.26,17.18-30.51,17.18-30.51l17.4-2.89L223,266.54h21.33l10.63-8.1,15.06-.63S290.12,265.06,287.21,288.32Z"
              fill="#a6e4f4"
            />
            <path
              d="M273.26,278s-12.06-6.47-12.78,4S279,315,264.54,326.87c0,0-4.06-11.67-12-12-7.3-.33-18.87,37.18-19.84,49.08-1-11.9-12.53-49.41-19.83-49.08-7.93.36-9.37,8.54-9.37,8.54-14.43-11.9,2.16-30.89,1.44-41.35s-12.78-4-12.78-4C190,260.73,205,255.35,205,255.35l16,10.71,4.51-4.22h15.87l5.41,4.22,13.7-10.71S275.42,260.73,273.26,278Z"
              fill="#425cad"
            />
            <path
              d="M256.61,272.89s-7.11-4.7-7.54,2.89,10.91,23.9,2.4,32.54c0,0-2.4-8.47-7.08-8.73-4.31-.24-11.14,27-11.71,35.62-.57-8.64-7.4-35.86-11.71-35.62-4.68.26-5.53,6.2-5.53,6.2-8.52-8.64,1.28-22.42.85-30s-7.54-2.89-7.54-2.89c-1.28-12.56,4-18,4-18l10.55,11.72,5.08-5.51h9.37l4.89,8.44L256.74,259S257.89,260.33,256.61,272.89Z"
              fill="#e7f4f7"
            />
            <path
              d="M232.71,432v4A19.86,19.86,0,0,1,232.71,432Z"
              fill="#e7f4f7"
            />
            <path
              d="M255,227.38v30.83s14.07,11.06,25.79,0V227.38Z"
              fill="#2e3f5b"
            />
            <path
              d="M187,232.07v22.85s14.07,8.21,25.79,0V232.07Z"
              fill="#2e3f5b"
            />
            <path
              d="M221,235.58v30.83s14.07,11.07,25.79,0V235.58Z"
              fill="#2e3f5b"
            />
            <path
              d="M255,227.38v21c8.72-1,18.17-2.81,25.79-10.43l-.12-10.55Z"
              fill="#152b4c"
              opacity="0.38"
            />
            <path
              d="M246.78,249.08v-13.5H221v12.86A25.36,25.36,0,0,0,246.78,249.08Z"
              fill="#152b4c"
              opacity="0.38"
            />
            <path
              d="M212.79,232.07H187l0,5.86a37.44,37.44,0,0,0,25.79,9.53Z"
              fill="#152b4c"
              opacity="0.38"
            />
            <path
              d="M187.08,212.14,187,232.07s52.75,16.41,93.77,0l-.16-19.34Z"
              fill="#2e3f5b"
            />
            <path
              d="M280.77,232.07l-.16-19.34-14.32-.09L230.78,218s-13.3,19.39-43.78,14.12C187,232.07,239.75,248.48,280.77,232.07Z"
              fill="#102849"
              opacity="0.38"
            />
            <path
              d="M232.71,218c112.52,1.76,136-83.8,136-83.8H96.17S120.2,216.24,232.71,218Z"
              fill="#bb8082"
            />
            <path
              d="M361.91,150.16c-4.77-5.22-10.23-10.68-10.82-10.68-1.17,0-19.93,14.06-19.93,14.06S255,173.47,199.31,171.12c0,0,82.63,8.21,60.36,27.54A144.09,144.09,0,0,1,230.78,218l1.93.05C314.14,219.28,348.91,174.82,361.91,150.16Z"
              fill="#6e7582"
            />
            <path
              d="M97.79,138.65C104.7,155.71,135.93,216.19,232,218c-77-12.26-92.82-72.67-95.09-83.78H125C116.6,135.5,105.42,137.27,97.79,138.65Z"
              fill="#f39189"
              opacity="0.48"
            />
            <path
              d="M129.91,182.71c28.16,8,64.54,12.79,104.27,12.79,38.67,0,74.17-4.56,102-12.16,25.34-23.06,32.49-49.14,32.49-49.14H96.17S103.68,159.81,129.91,182.71Z"
              fill="#1e3b68"
              opacity="0.38"
            />
            <ellipse
              cx="232.42"
              cy="134.2"
              rx="161.74"
              ry="54.26"
              fill="#2e3f5b"
              stroke="#36f2e9"
              strokeMiterlimit="10"
            />
            <path
              d="M397.74,143.51c0,1.93-4.06,3.5-14,3.5s-22-4.07-22-6,9.05,3,19,3S397.74,141.58,397.74,143.51Z"
              fill="#1e3b68"
              opacity="0.38"
            />
            <ellipse
              cx="232.42"
              cy="134.2"
              rx="136.25"
              ry="45.71"
              fill="#ddad9b"
            />
            <path
              d="M230.37,65.93c34.53,0,66.44,3.26,92.34,8.77,3.35-4.36,6.41-9,10.09-13C303.68,54.93,268.4,51,230.37,51A489.13,489.13,0,0,0,146,58a129,129,0,0,1,8.05,13.72A482,482,0,0,1,230.37,65.93Z"
              fill="#2e3f5b"
              stroke="#36f2e9"
              strokeMiterlimit="10"
            />
            <path
              d="M103,174.27c-38.79-8.32-60.46-31.1-60.46-46.22,0-17.17,32.47-39.16,80.47-47a126.36,126.36,0,0,0-8-13.72c-57.35,10.17-96.44,37.41-96.44,60.69,0,19.39,23.6,46,65.81,57.13C85.53,184.53,98.23,177.5,103,174.27Z"
              fill="#2e3f5b"
              stroke="#36f2e9"
              strokeMiterlimit="10"
            />
            <path
              d="M146.13,194.76c20.22,12.7,48.06,22.54,86,23.23h7.22c35.1-.53,61.11-9.76,80.19-21.92-24.13,4.43-52.69,7-83.3,7C202.69,203.06,171.62,200,146.13,194.76Z"
              fill="#1e3b68"
              opacity="0.38"
            />
            <path
              d="M363.78,174.27c38.79-8.32,60.45-31.1,60.45-46.22,0-17.17-32.46-39.16-80.47-47a128,128,0,0,1,8.05-13.72c57.36,10.17,96.45,37.41,96.45,60.69,0,19.39-23.61,46-65.82,57.13C381.25,184.53,368.55,177.5,363.78,174.27Z"
              fill="#2e3f5b"
              stroke="#36f2e9"
              strokeMiterlimit="10"
            />
            <path
              d="M339.31,201.18c-3.25-3.48-6.65-6.87-9.9-10.72-.51-.68-1-1.35-1.56-2C302,194,270.11,197.2,235.64,197.2c-34.72,0-66.8-3.3-92.78-8.87-4.78,3.24-9.24,7-15,9.16a39,39,0,0,0-3.63,1.76c30.71,8.08,69.41,12.89,111.45,12.89C274.22,212.14,310,208.09,339.31,201.18Z"
              fill="#2e3f5b"
              stroke="#36f2e9"
              strokeMiterlimit="10"
            />
            <polygon
              points="260.1 125.22 255.78 129.34 244.83 139.62 207.66 141.01 223.92 125.22 260.1 125.22"
              fill="#2e3f5b"
              stroke="#36f2e9"
              strokeMiterlimit="10"
            />
            <polygon
              points="300.11 105.25 241.11 161.45 222.07 161.45 255.78 129.34 260.16 125.22 260.1 125.22 281.06 105.25 300.11 105.25"
              fill="#2e3f5b"
              stroke="#36f2e9"
              strokeMiterlimit="10"
            />
            <polygon
              points="244.83 105.25 185.83 161.45 166.79 161.45 225.78 105.25 244.83 105.25"
              fill="#2e3f5b"
              stroke="#36f2e9"
              strokeMiterlimit="10"
            />
            <line
              x1="394.16"
              y1="133.91"
              x2="509.61"
              y2="133.91"
              fill="#046582"
              stroke="#6ef4ed"
              strokeMiterlimit="10"
              strokeWidth="0.62"
            />
            <line
              x1="70.68"
              y1="133.91"
              x2="6.5"
              y2="133.91"
              fill="#046582"
              stroke="#6ef4ed"
              strokeMiterlimit="10"
              strokeWidth="0.62"
            />
            <line
              x1="232.42"
              y1="80"
              x2="231.83"
              y2="22.57"
              fill="#046582"
              stroke="#6ef4ed"
              strokeMiterlimit="10"
              strokeWidth="0.62"
            />
            <line
              x1="233.59"
              y1="188.41"
              x2="233.59"
              y2="247.6"
              fill="#046582"
              stroke="#6ef4ed"
              strokeMiterlimit="10"
              strokeWidth="0.62"
            />
            <circle cx="5.57" cy="134.03" r="5.57" fill="#6ef4ed" />
            <circle cx="231.83" cy="22.57" r="5.57" fill="#6ef4ed" />
            <circle cx="233.01" cy="247.6" r="5.57" fill="#6ef4ed" />
            <circle cx="510.19" cy="133.32" r="5.57" fill="#6ef4ed" />
            <path
              d="M199.31,214.83l-12.23-2.69L187,232.07C191.11,218.59,199.31,214.83,199.31,214.83Z"
              fill="#f39189"
              opacity="0.48"
            />
          </g>
          <circle
            cx="228"
            cy="304.5"
            r="69"
            strokeMiterlimit="10"
            opacity="0.65"
            fill="url(#bf5d73cb-97c8-467e-98c0-b824c3393bca)"
            stroke="url(#a92a2720-bd9d-49bf-9fc6-d08359e2e19e)"
          />
          <g>
            <g>
              <path
                d="M412,121v7.34c0,.67-.69,1.31-2,1.91-4.5,2.12-16.34,3.64-30.24,3.64s-25.74-1.52-30.25-3.64c-1.26-.6-1.94-1.24-1.94-1.91V121c0,1.41,3,2.69,8.06,3.67a134.67,134.67,0,0,0,24.13,1.88,134.67,134.67,0,0,0,24.13-1.88C408.94,123.71,412,122.43,412,121Z"
                fill="#9fb8ad"
              />
              <path
                d="M411.82,119.39v7.34c0,.67-.69,1.31-1.95,1.9-4.51,2.13-16.35,3.65-30.24,3.65s-25.74-1.52-30.25-3.65c-1.26-.59-1.95-1.23-1.95-1.9v-7.34c0,1.4,3.05,2.69,8.06,3.67a134.93,134.93,0,0,0,24.14,1.87,134.89,134.89,0,0,0,24.13-1.87C408.77,122.08,411.82,120.79,411.82,119.39Z"
                fill="#9fb8ad"
              />
              <path
                d="M411.82,121.58v5.15c0,.67-.69,1.31-1.95,1.9-4.51,2.13-16.35,3.65-30.24,3.65s-25.74-1.52-30.25-3.65a3.93,3.93,0,0,1-1.78-1.34v1.07c0,.67.68,1.31,1.94,1.91,4.51,2.12,16.35,3.64,30.25,3.64s25.74-1.52,30.24-3.64c1.26-.6,2-1.24,2-1.91V121A1.19,1.19,0,0,1,411.82,121.58Z"
                fill="#434c68"
                opacity="0.56"
                style={{ mixBlendMode: 'multiply' }}
              />
              <path
                d="M411.82,119.55c0,1.41-3.05,2.69-8.06,3.67a134.76,134.76,0,0,1-24.13,1.88,134.8,134.8,0,0,1-24.14-1.88c-5-1-8.06-2.26-8.06-3.67,0-3.07,14.42-5.55,32.2-5.55S411.82,116.48,411.82,119.55Z"
                fill="#c5d7bd"
              />
              <image
                width="81"
                height="79"
                transform="translate(363.5 89)"
                xlinkHref="data:image/png;base64,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"
              />
              <path
                d="M405.83,121.51c0,1.14-2.47,2.18-6.52,3a126.1,126.1,0,0,1-39,0c-4.06-.79-6.52-1.83-6.52-3,0-2.48,11.66-4.49,26-4.49S405.83,119,405.83,121.51Z"
                fill="#434c68"
                style={{ mixBlendMode: 'multiply' }}
              />
              <path
                d="M396.36,123c0,.72-1.57,1.38-4.15,1.89a80.82,80.82,0,0,1-24.84,0c-2.58-.51-4.15-1.17-4.15-1.89,0-1.58,7.42-2.86,16.57-2.86S396.36,121.4,396.36,123Z"
                fill="#9fb8ad"
                stroke="#efe922"
                strokeMiterlimit="10"
                strokeWidth="0.08"
              />
              <path
                d="M393.46,123c0,.59-1.3,1.14-3.42,1.55a66.06,66.06,0,0,1-20.5,0c-2.13-.41-3.42-1-3.42-1.55,0-1.31,6.12-2.36,13.67-2.36S393.46,121.67,393.46,123Z"
                fill="#383e56"
                stroke="#efe922"
                strokeMiterlimit="10"
                strokeWidth="0.33"
              />
              <path
                d="M391.15,123c0,.49-1.07,1-2.84,1.29a55.32,55.32,0,0,1-17,0c-1.77-.34-2.84-.8-2.84-1.29,0-1.09,5.08-2,11.36-2S391.15,121.89,391.15,123Z"
                fill="#9fb8ad"
                stroke="#efe922"
                strokeMiterlimit="10"
                strokeWidth="0.08"
              />
              <path
                d="M388.72,123c0,.39-.84.74-2.23,1a43.42,43.42,0,0,1-13.4,0c-1.39-.28-2.24-.63-2.24-1,0-.85,4-1.54,8.94-1.54S388.72,122.13,388.72,123Z"
                fill="#383e56"
                stroke="#efe922"
                strokeMiterlimit="10"
                strokeWidth="0.33"
              />
              <path
                d="M400,127.71v3.43s5.88-.66,8.16-1.88V126A35.17,35.17,0,0,1,400,127.71Z"
                fill="url(#b93d8e63-3a65-4a32-b7a0-97e3ab75c2fc)"
              />
              <image
                width="78"
                height="76"
                transform="translate(355.5 92)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAABMCAYAAADDYoEWAAAACXBIWXMAAAsSAAALEgHS3X78AAAD+UlEQVR4Xu2au27jMBBFL7MCNkacIkV6F+5S5gf1gynTLFy4d5EiDjYLOOEW1EgkNTQlmqSFYA5g2HqCczCkyJGV1hrCfG5iJwg8Ii4REZeIiEtExCUi4hIRcYmIuEREXCIiLhERl4iIS0TEJSLiEhFxiSxXnFIKSqnYaddCLaKQOVfQAhp9PXFzZYW4UgD1xeUS5lM5kHripgmLnRNvbKWAyouLC7OOt8GTmOPnG144sLLizkvrjrXe7tfANU9eQ1v6EQ6gYHDlxIWlMcJCskLYElv6wQdSKMCa4pguyQk7BCQ+Mg0lga290z2vUIBlxAWltd2mLywkK4QvcSSwuLz84vguqkxQMWHv3fazuxsv3fe911hOYAtw3TZzoE3shAxEuiMn68275pmCVq5Eus+oGyvEnroXkjfjJmUbBWsL80UBeOq+X0dHADzocRaSvDpZV1qcGo9rBxWWdlTYgmcHAGursb48WxzAyssYbKXqiJ9tgCvtqLC1pJ3+KucDAFsA26MCjt01b8rt3nTvuVObNPJl3Kxss6RtOxEkCBvw7M1XszIN3lH2UebVzboKDwcu26xMAzppG7Pr9MFnTLMxAZ/2ysg7KtN13xR6OQdl5L2q8UojL6W6aqC7ULYB/XhG0k4fypH2/anw/Tls98c35pptdw8A5p7vw7kuRbpuHnHs07QFn20RfGH+dhR7rGvHh+NFh0nkETcLGtvgZhuAs4Lo2CjrAHY6U5jK4vwVQYCvf8r5TGLivTNRUZw1BtGTdGq2EX7WAda9gDPjXHYqivtZVBRnLdD7OdgeaO7M75vb+PSBzmnudD+v29mrCb8IUI6K4oBhiRTh12/tfCYx8d6ZqCwOMDN9mLVns9KTs87PtmalzfoV6O9ZkTzi2GVMi2H2zlVvA9zcakegvx1lVCVxybTkyiNuTKBx93roUms9yjrKPGAsrD++t7KNxjdaq7JkEeVTYa36pM0s/lEPs/oHbSataw0czdrztDfHaE06Ym++aJEPe5FP+Iv8cuSrjgBnKiRcEdMvK1lX9ZWSjl4WvLqcXRkBosXMjMGW6qoe3Fj3giFb1hq79TDYNyvtfAAjbLfWY2lEvWwDymccIKXziZx9NchVS6a8rLHHMe6NF/skLdZNgSoPB2iMamIU6EENAv7AkugFacu6t/YHpzlZJXHkzzhAXkhfhPwFIhH5080FyN+8LiBe42e6cAjn+PmGFw6svDgiLhCIv5GKN7ZSQPXEEdMEzqdyIPXFEbkEXimA64mzmStxAY1ehjgOkrnQBi5X3MKpVFb6eYi4RERcIiIuERGXiIhLRMQlIuISEXGJiLhERFwiIi4REZeIiEtExCXyH+VvEWPSp0F0AAAAAElFTkSuQmCC"
              />
              <path
                d="M353.72,121.51c1.59.14,3.17.38,4.75.61s3.15.51,4.71.86c-1.59-.15-3.17-.39-4.75-.62S355.28,121.85,353.72,121.51Z"
                fill="#1ef9aa"
              />
              <path
                d="M358.45,118.93c.94.47,1.83,1,2.73,1.55s1.76,1.12,2.59,1.76c-.94-.46-1.83-1-2.72-1.55S359.28,119.57,358.45,118.93Z"
                fill="#1ef9aa"
              />
              <path
                d="M363.77,118a18.07,18.07,0,0,1,1.62,1.53,19.55,19.55,0,0,1,1.45,1.69,18,18,0,0,1-1.62-1.52A19.69,19.69,0,0,1,363.77,118Z"
                fill="#1ef9aa"
              />
              <path
                d="M368.5,117.46a11,11,0,0,1,.68,1.53,10,10,0,0,1,.45,1.62,11,11,0,0,1-.68-1.53A12.5,12.5,0,0,1,368.5,117.46Z"
                fill="#1ef9aa"
              />
              <path
                d="M372.21,117.21a10.35,10.35,0,0,1,.55,3.18,11.21,11.21,0,0,1-.55-3.18Z"
                fill="#1ef9aa"
              />
              <path
                d="M375.48,117.08a10.33,10.33,0,0,1,0,3.14,9.24,9.24,0,0,1-.13-1.57A10.39,10.39,0,0,1,375.48,117.08Z"
                fill="#1ef9aa"
              />
              <path
                d="M378.31,117.08a9.75,9.75,0,0,1,0,3,8.75,8.75,0,0,1-.13-1.52A9.87,9.87,0,0,1,378.31,117.08Z"
                fill="#1ef9aa"
              />
              <path
                d="M381.57,117.08a8.79,8.79,0,0,1,0,1.54,8.7,8.7,0,0,1-.27,1.51,9.77,9.77,0,0,1,.3-3Z"
                fill="#1ef9aa"
              />
              <path
                d="M384.11,117.08a10.84,10.84,0,0,1-.69,3.11,10.84,10.84,0,0,1,.69-3.11Z"
                fill="#1ef9aa"
              />
              <path
                d="M387.37,117.21a9.81,9.81,0,0,1-.47,1.54,9.26,9.26,0,0,1-.71,1.45,11.93,11.93,0,0,1,.48-1.54A10.17,10.17,0,0,1,387.37,117.21Z"
                fill="#1ef9aa"
              />
              <path
                d="M390,117.38a11.82,11.82,0,0,1-.78,1.55,9.86,9.86,0,0,1-1,1.43,12.48,12.48,0,0,1,.78-1.55A11.74,11.74,0,0,1,390,117.38Z"
                fill="#1ef9aa"
              />
              <path
                d="M393.33,117.67a14.11,14.11,0,0,1-1.06,1.55,13.75,13.75,0,0,1-1.26,1.39,14,14,0,0,1,1.06-1.54A15.17,15.17,0,0,1,393.33,117.67Z"
                fill="#1ef9aa"
              />
              <path
                d="M396.36,118a20.9,20.9,0,0,1-1.73,1.67,19.23,19.23,0,0,1-1.89,1.48,22.53,22.53,0,0,1,1.73-1.66A21,21,0,0,1,396.36,118Z"
                fill="#1ef9aa"
              />
              <path
                d="M399.66,118.61c-.74.61-1.53,1.15-2.32,1.69s-1.6,1-2.46,1.5c.74-.62,1.54-1.16,2.32-1.7S398.8,119.05,399.66,118.61Z"
                fill="#1ef9aa"
              />
              <path
                d="M403.31,119.58c-1.1.66-2.26,1.23-3.4,1.81s-2.32,1.11-3.52,1.59c1.11-.66,2.26-1.23,3.41-1.81S402.12,120.06,403.31,119.58Z"
                fill="#1ef9aa"
              />
              <path
                d="M404.4,123c-1.47.25-2.95.4-4.43.57s-3,.28-4.45.33c1.47-.26,3-.41,4.43-.58S402.91,123,404.4,123Z"
                fill="#1ef9aa"
              />
              <path
                d="M395.52,125.08a2.75,2.75,0,0,1-.81-.2,3,3,0,0,1-.71-.44,3,3,0,0,1,.81.21A2.59,2.59,0,0,1,395.52,125.08Z"
                fill="#1ef9aa"
              />
              <path
                d="M357.67,123.88c1-.11,2-.11,3.05-.13s2,0,3,.13c-1,.1-2,.1-3,.12S358.69,124,357.67,123.88Z"
                fill="#1ef9aa"
              />
              <path
                d="M364.52,125.14a3.42,3.42,0,0,1,.76-.39,2.55,2.55,0,0,1,.83-.16,2.56,2.56,0,0,1-.75.39A2.61,2.61,0,0,1,364.52,125.14Z"
                fill="#1ef9aa"
              />
              <path
                d="M410.07,130.43l-2.05,2-7.4,7.15c0,2-9.35,3.55-20.87,3.48s-20.84-1.72-20.83-3.71l-6.83-6.76-2.51-2.48c4.5,2.15,16.33,3.73,30.22,3.81S405.55,132.54,410.07,130.43Z"
                fill="#434c68"
              />
              <path
                d="M391.74,128.61V132a30.5,30.5,0,0,0,5.63-.41V128.2A33.9,33.9,0,0,1,391.74,128.61Z"
                fill="url(#b904d390-402a-44a2-bc7a-726543f63655)"
              />
              <path
                d="M400.62,139.57l.36-.34c-20.35,2.49-34.23,1.28-42.39-.22l.33.33c0,2,9.32,3.65,20.83,3.71S400.61,141.56,400.62,139.57Z"
                fill="#434c68"
                style={{ mixBlendMode: 'multiply' }}
              />
              <ellipse
                cx="379.56"
                cy="120.34"
                rx="30.55"
                ry="6.19"
                opacity="0.44"
                fill="url(#f5646a17-839a-40d9-accc-d2c771dfc960)"
                style={{ mixBlendMode: 'color-dodge' }}
              />
            </g>
            <ellipse
              cx="379.58"
              cy="60.45"
              rx="39.58"
              ry="20.45"
              fill="none"
              stroke="#9f3aef"
              strokeMiterlimit="10"
              strokeWidth="6.6"
            />
            <image
              width="159"
              height="120"
              transform="translate(300.5)"
              xlinkHref="data:image/png;base64,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"
            />
            <ellipse
              cx="380.58"
              cy="60.45"
              rx="39.58"
              ry="20.45"
              fill="none"
              stroke="#e1e1ef"
              strokeMiterlimit="10"
              strokeWidth="1.32"
            />
            <path
              d="M404.5,77c0,7.18-17.82,48-25,48s-26-38.82-26-46,18.82,2,26,2S404.5,69.82,404.5,77Z"
              opacity="0.44"
              fill="url(#a8558419-dbb8-4ed0-962d-2eeb95accd20)"
              style={{ mixBlendMode: 'color-dodge' }}
            />
            <polygon
              points="380.72 45.42 385.9 55.93 397.5 57.61 389.11 65.79 391.09 77.34 380.72 71.89 370.35 77.34 372.33 65.79 363.94 57.61 375.53 55.93 380.72 45.42"
              fill="#f4e91e"
            />
          </g>
        </g>
      </g>
      <g className="text" transform="translate(160 180)">
        <path
          fill="#ffffff"
          d="M20.1,14.4c-0.3-2.3-0.8-4.5-1.3-6.6c-0.1-0.5-0.3-1.1-0.4-1.6c0,0,0,0,0,0c-0.5-1.6-1-3.2-1.5-4.7
          c-0.1-0.4-0.3-0.7-0.5-0.8c-0.2-0.2-0.5-0.3-0.9-0.3c-0.1,0-0.2,0-0.3,0h-0.3c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.7,0.1
          c-0.7,0.1-1.1,0.4-1.3,1c-0.5,1.2-0.9,2.4-1.2,3.6c-0.3,1.2-0.6,2.4-0.9,3.6C9.8,7.2,9.4,6,9.1,4.8C8.7,3.6,8.3,2.5,7.8,1.3
          C7.6,1,7.5,0.7,7.3,0.5C7.1,0.4,6.8,0.3,6.5,0.3c-0.1,0-0.2,0-0.3,0H5.9c-0.2,0-0.4,0-0.7,0c-0.2,0-0.5,0-0.7,0.1
          C4.1,0.4,3.9,0.5,3.7,0.6C3.5,0.8,3.4,1,3.3,1.3C2.6,3.6,1.9,5.7,1.4,7.8c-0.5,2.1-1,4.2-1.3,6.4c0,0.1,0,0.2,0,0.2
          c0,0.1,0,0.2,0,0.2c0,0.5,0.3,0.8,0.8,0.9c0.3,0.1,0.6,0.1,0.9,0.1c0.3,0,0.7,0,1.1,0c0.5,0,0.8-0.1,0.9-0.3C3.9,15.3,4,15,4,14.7
          c0.2-1.6,0.4-3.1,0.6-4.5c0.2-1.4,0.5-2.7,0.8-4C5.8,7.6,6.2,9,6.5,10.4c0.3,1.3,0.7,2.5,1.2,3.8c0,0.1,0.1,0.2,0.1,0.3
          c0.1,0.4,0.3,0.6,0.6,0.8c0.2,0.2,0.6,0.3,1,0.3c0.5,0,1-0.1,1.6-0.2c0.3-0.1,0.6-0.2,0.7-0.4c0.2-0.2,0.3-0.4,0.4-0.7
          c0.5-1.3,0.9-2.7,1.2-4c0,0,0,0,0,0c0.3-1.3,0.6-2.7,0.9-4c0.2,1,0.5,1.9,0.7,2.8c0.1,0.5,0.2,1.1,0.3,1.6c0.3,1.5,0.6,2.9,0.8,4.4
          c0.1,0.4,0.2,0.6,0.5,0.7c0.2,0.1,0.5,0.1,0.9,0.1s0.7,0,1.1-0.1c0.4,0,0.7-0.1,1-0.2c0.4-0.1,0.6-0.4,0.6-0.9
          C20.1,14.6,20.1,14.5,20.1,14.4z"
        />
        <path
          fill="#ffffff"
          d="M25.4,1.1c-0.1-0.3-0.2-0.5-0.4-0.7c-0.1-0.1-0.2-0.2-0.3-0.2h0c-0.1-0.1-0.2-0.1-0.4-0.1
          C24.1,0,23.7,0,23.3,0c-0.8,0-1.3,0.2-1.6,0.5c-0.3,0.3-0.5,0.8-0.5,1.5c0,0.4,0,0.8,0.1,1c0,0.1,0.1,0.2,0.1,0.3
          c0.1,0.1,0.1,0.2,0.2,0.3C21.8,3.9,22.1,4,22.3,4c0.3,0.1,0.6,0.1,1,0.1c0.4,0,0.8,0,1.1-0.1c0.3-0.1,0.5-0.2,0.7-0.4
          c0.2-0.2,0.3-0.4,0.3-0.6c0.1-0.2,0.1-0.5,0.1-0.8C25.6,1.8,25.5,1.4,25.4,1.1z M25.1,5.3c-0.1-0.1-0.2-0.2-0.4-0.2
          c-0.1,0-0.2,0-0.3,0H24c-0.3,0-0.6,0-0.9,0c-0.3,0-0.6,0.1-0.8,0.1c-0.3,0-0.5,0.2-0.5,0.4c-0.1,0.2-0.1,0.5-0.1,0.8
          c-0.1,0.8-0.1,1.7-0.1,2.5c0,0.8,0,1.6,0,2.4c0,0.5,0,1,0,1.5c0,0.5,0,1,0.1,1.5c0,0.4,0.1,0.6,0.2,0.8c0.1,0.2,0.4,0.3,0.9,0.3
          c0.4,0,0.8,0.1,1.2,0.1c0.3,0,0.5,0,0.6-0.1c0.2,0,0.3-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.2-0.4c0-0.2,0-0.3,0-0.6
          c0.1-1.4,0.2-2.8,0.2-4.2c0-1.3,0.1-2.8,0.1-4.3C25.2,5.6,25.1,5.4,25.1,5.3z"
        />
        <path
          fill="#ffffff"
          d="M32.2,8.5c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0.1,0.9,0.1,1.3,0.1c0.3,0,0.5-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.3-0.5
          C35,8,35,7.6,35.1,7.2c0.1-0.4,0.1-0.7,0.1-1c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.2-0.3-0.3-0.5-0.3C34,5.1,33.6,4.9,33,4.9
          c-0.5-0.1-1.1-0.1-1.6-0.1c-0.6,0-1.2,0.1-1.8,0.2c-0.6,0.2-1.1,0.4-1.5,0.7C27.6,6,27.3,6.3,27,6.7c-0.3,0.4-0.4,0.9-0.4,1.4
          c0,0.5,0.1,1,0.3,1.4c0.2,0.4,0.5,0.7,0.8,1c0.3,0.3,0.7,0.5,1.1,0.7c0.4,0.2,0.7,0.3,1.1,0.5c0.3,0.1,0.6,0.3,0.8,0.4
          c0.2,0.1,0.3,0.3,0.3,0.4c0,0.2-0.1,0.3-0.3,0.4c-0.2,0.1-0.5,0.1-0.8,0.1c-0.2,0-0.5,0-0.8-0.1c-0.3-0.1-0.6-0.2-0.8-0.3
          c-0.3-0.1-0.5-0.2-0.6-0.2c-0.2,0-0.3,0.1-0.4,0.5c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2-0.2,0.5-0.2,0.7c0,0.2-0.1,0.3-0.1,0.5
          c0,0.3,0.2,0.6,0.6,0.7c0.4,0.2,0.9,0.3,1.4,0.4c0.5,0.1,1,0.1,1.6,0.1c0.7,0,1.3-0.1,1.9-0.2c0.6-0.2,1.1-0.4,1.5-0.6
          c0.4-0.3,0.8-0.6,1-1c0.2-0.4,0.4-0.8,0.4-1.3c0-0.6-0.1-1-0.4-1.4c-0.2-0.4-0.5-0.7-0.9-1C33.4,10,33,9.8,32.6,9.6
          c-0.4-0.2-0.8-0.3-1.2-0.5C31,9,30.7,8.8,30.4,8.7c-0.2-0.1-0.4-0.3-0.4-0.4c0-0.2,0.1-0.4,0.4-0.5c0.2-0.1,0.6-0.1,0.9-0.1
          c0.2,0,0.4,0,0.7,0.1v0.2C32.1,8.2,32.1,8.4,32.2,8.5z"
        />
        <path
          fill="#ffffff"
          d="M46.3,13.6c0-0.1-0.1-0.2-0.1-0.4c-0.1-0.2-0.2-0.4-0.2-0.5c-0.1-0.2-0.2-0.3-0.3-0.5
          c-0.2-0.3-0.3-0.4-0.5-0.4c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0.1-0.4,0.2c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0.1-0.4,0.2-0.6,0.2
          c-0.2,0.1-0.4,0.1-0.7,0.2c-0.2,0-0.4,0.1-0.6,0.1c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.4-0.5-0.5-0.8
          c-0.1-0.3-0.2-0.6-0.2-1c0-0.4,0.1-0.7,0.2-1C40,9,40.2,8.7,40.5,8.5C40.7,8.3,41,8.1,41.4,8c0.3-0.1,0.7-0.2,1.1-0.3
          c0,0.2,0,0.4,0,0.7c0,0.2,0,0.4,0.1,0.6c0.1,0.6,0.4,0.9,1,1c0.3,0.1,0.7,0.1,1.2,0.1c0.3,0,0.5-0.1,0.6-0.2
          c0.1-0.1,0.2-0.3,0.2-0.6c0.1-0.5,0.1-1,0.1-1.5c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4-0.1-0.7c0-0.4-0.1-0.7-0.3-0.9
          c-0.1-0.2-0.4-0.3-0.7-0.5c-0.4-0.1-0.7-0.2-1.1-0.3c-0.4,0-0.7-0.1-1-0.1c-0.8,0-1.7,0.1-2.4,0.4c-0.8,0.3-1.5,0.7-2.1,1.2
          c-0.6,0.5-1.1,1.1-1.5,1.8c-0.4,0.7-0.6,1.4-0.6,2.2c0,0.3,0,0.6,0.1,0.9c0.1,0.4,0.2,0.7,0.3,1.1s0.4,0.8,0.6,1.2
          c0.3,0.4,0.6,0.8,1.1,1c0.4,0.3,1,0.6,1.7,0.8c0.7,0.2,1.4,0.3,2.3,0.3c0.4,0,0.8,0,1.1-0.1c0.4-0.1,0.8-0.1,1.1-0.3
          c0.4-0.1,0.7-0.2,1-0.4c0.3-0.2,0.6-0.3,0.8-0.5c0.2-0.2,0.3-0.4,0.3-0.6C46.3,13.8,46.3,13.7,46.3,13.6z"
        />
        <path
          fill="#ffffff"
          d="M57.8,8.3c-0.2-0.6-0.5-1.1-0.9-1.6c-0.4-0.5-1-1-1.6-1.3c-0.7-0.4-1.5-0.5-2.5-0.5c-0.7,0-1.4,0.1-2.1,0.4
          c-0.7,0.3-1.3,0.7-1.8,1.1c-0.5,0.5-0.9,1.1-1.2,1.8c-0.3,0.7-0.5,1.4-0.5,2.2c0,0.8,0.2,1.6,0.5,2.2c0.3,0.7,0.7,1.2,1.2,1.7
          c0.5,0.5,1.1,0.8,1.7,1.1c0.7,0.3,1.3,0.4,2,0.4c1,0,1.9-0.1,2.6-0.4s1.4-0.6,1.8-1c0.2-0.2,0.3-0.5,0.3-0.7v-0.2
          c0-0.1,0-0.1,0-0.2c0-0.2-0.1-0.3-0.1-0.5c0-0.2-0.1-0.3-0.1-0.5C57,12.2,57,12.1,56.9,12c-0.1-0.1-0.1-0.1-0.3-0.1
          c-0.1,0-0.2,0-0.5,0.1c-0.4,0.2-0.9,0.4-1.4,0.5c-0.5,0.1-0.9,0.2-1.3,0.2c-0.5,0-1-0.1-1.4-0.3c-0.5-0.2-0.8-0.5-1.1-0.8
          c0.6,0,1.2-0.1,1.8-0.1c0.6-0.1,1.2-0.1,1.8-0.2c0.6-0.1,1.1-0.2,1.6-0.3c0.5-0.1,0.9-0.2,1.3-0.4c0.2-0.1,0.4-0.2,0.4-0.3
          c0.1-0.1,0.1-0.3,0.1-0.5C58.1,9.3,58,8.9,57.8,8.3z M52.6,9.3c-0.7,0.1-1.4,0.1-2,0.1C50.7,9,51,8.6,51.5,8.3
          c0.4-0.3,0.9-0.4,1.4-0.4c0.3,0,0.7,0.1,1,0.3c0.3,0.2,0.6,0.5,0.7,0.9C54,9.1,53.3,9.2,52.6,9.3z"
        />
        <path
          fill="#ffffff"
          d="M63,2L63,2c0-0.4,0-0.7,0-1c0-0.3,0-0.6-0.1-0.7c-0.1-0.1-0.2-0.2-0.5-0.2c-0.3,0-0.7,0-1.1,0.1
          c-0.4,0-0.8,0.1-1.1,0.2c-0.2,0.1-0.4,0.2-0.5,0.3c-0.1,0.1-0.1,0.3-0.2,0.7c0,0.1,0,0.2,0,0.3c-0.1,1.2-0.2,2.4-0.2,3.7
          c0,1.3-0.1,2.5-0.1,3.8c0,1.1,0,2.1,0,3.1c0,0.9,0.1,1.7,0.1,2.4c0,0.3,0.1,0.6,0.2,0.8c0.1,0.2,0.4,0.3,0.9,0.3c0.1,0,0.2,0,0.3,0
          h0.6c0.1,0,0.2,0,0.3,0c0.5,0,0.7-0.2,0.8-0.4c0.1-0.2,0.2-0.5,0.2-0.9c0.1-0.6,0.1-1.4,0.2-2.3s0.1-1.8,0.1-2.8c0-1,0-2,0.1-3.1
          s0-2.1,0-3.1C63,2.7,63,2.4,63,2z"
        />
        <path
          fill="#ffffff"
          d="M68.6,2c0-0.3,0-0.7,0-1c0-0.3,0-0.6-0.2-0.7c-0.1-0.1-0.3-0.2-0.5-0.2c-0.3,0-0.7,0-1.1,0.1
          c-0.4,0-0.8,0.1-1.1,0.2c-0.2,0.1-0.4,0.2-0.4,0.3c-0.1,0.2-0.2,0.5-0.2,1c0,0.2,0,0.3,0,0.5c-0.1,1-0.2,2-0.2,3.1
          c0,1.3-0.1,2.5-0.1,3.8c0,1.1,0,2.1,0,3.1c0,0.9,0.1,1.7,0.1,2.4c0,0.3,0.1,0.6,0.2,0.8c0.1,0.2,0.4,0.3,0.9,0.3c0.1,0,0.2,0,0.3,0
          H67c0.1,0,0.2,0,0.3,0c0.5,0,0.7-0.2,0.8-0.4c0.1-0.2,0.1-0.5,0.2-0.9c0.1-0.6,0.1-1.4,0.1-2.3c0.1-0.9,0.1-1.8,0.1-2.8
          c0-1,0.1-2,0.1-3.1c0-1.1,0-2.1,0-3.1V2.7C68.6,2.5,68.6,2.2,68.6,2z"
        />
        <path
          fill="#ffffff"
          d="M81.7,5.7c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.3-0.2s-0.3-0.1-0.5-0.2c-0.3-0.1-0.7-0.2-1.1-0.2
          c-0.4,0-0.7-0.1-1-0.1c-0.2,0-0.3,0-0.4,0.1C78.1,4.8,78,5,78,5.3c-0.6-0.3-1.2-0.4-1.9-0.4c-0.8,0-1.5,0.2-2.2,0.5
          c-0.7,0.3-1.4,0.8-2,1.4c-0.6,0.6-1,1.3-1.4,2.1c-0.4,0.8-0.5,1.6-0.5,2.6c0,0.6,0.1,1.2,0.3,1.8c0.2,0.5,0.5,1,0.9,1.4
          c0.4,0.4,0.9,0.7,1.4,0.9c0.5,0.2,1.2,0.3,1.8,0.3c0.6,0,1.2-0.1,1.7-0.3c0.5-0.2,1.1-0.5,1.5-0.9c0,0.3,0.1,0.5,0.1,0.7
          c0.1,0.2,0.3,0.3,0.7,0.3c0.1,0,0.2,0,0.3,0h0.8c0.2,0,0.3,0,0.4,0c0.4,0,0.6-0.2,0.8-0.3c0.2-0.2,0.2-0.5,0.3-0.9
          c0.2-1.3,0.3-2.7,0.3-4.1c0.1-1.4,0.1-2.8,0.1-4.1C81.7,6,81.7,5.8,81.7,5.7z M77.9,10c0,0.6-0.1,1.1-0.1,1.7
          c-0.3,0.3-0.7,0.6-1,0.7c-0.4,0.2-0.7,0.2-1.1,0.2c-0.6,0-1.1-0.2-1.4-0.5c-0.3-0.3-0.5-0.8-0.5-1.3c0-0.3,0.1-0.6,0.2-0.9
          c0.1-0.3,0.3-0.6,0.5-0.9c0.2-0.3,0.5-0.5,0.8-0.7C75.8,8,76.2,8,76.6,8c0.3,0,0.5,0,0.8,0.1c0.2,0,0.5,0.1,0.7,0.2
          C78,8.8,78,9.4,77.9,10z"
        />
        <path
          fill="#ffffff"
          d="M93.8,6.2c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2-0.2-0.4-0.4-0.6-0.6c-0.3-0.2-0.7-0.3-1.1-0.4
          c-0.4-0.1-0.7-0.1-1-0.1c-0.6,0-1.2,0.1-1.8,0.3c-0.2,0.1-0.3,0.1-0.5,0.2c-0.4,0.2-0.8,0.4-1.2,0.7c0-0.1,0-0.2,0-0.3
          c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1-0.1-0.2c-0.1-0.1-0.2-0.2-0.4-0.2c-0.2,0-0.4,0-0.6,0c-0.2,0-0.5,0-0.7,0.1
          c-0.1,0-0.1,0-0.1,0h0c-0.2,0-0.4,0-0.5,0.1C84.5,5,84.3,5,84.2,5c-0.3,0.1-0.5,0.2-0.5,0.4c-0.1,0.2-0.1,0.5-0.1,0.8
          c0,0.3,0,0.5,0,0.8v0.8c0,1.1,0,2.2,0.1,3.4c0.1,1.1,0.2,2.2,0.3,3.3c0.1,0.3,0.1,0.6,0.3,0.8c0.1,0.2,0.4,0.3,0.9,0.3
          c0.1,0,0.2,0,0.3,0h0.7c0.1,0,0.2,0,0.3,0c0.5,0,0.8-0.1,0.9-0.2c0.2-0.1,0.2-0.3,0.2-0.6c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.2
          c-0.1-0.9-0.2-1.8-0.2-2.7c-0.1-0.9-0.1-1.8-0.1-2.8c0.4-0.3,0.8-0.5,1.2-0.6c0.4-0.1,0.8-0.2,1.1-0.2c0.3,0,0.5,0.1,0.6,0.3
          c0.1,0.2,0.2,0.5,0.2,0.8c0,0.9,0,1.6,0,2.2c0,0.6,0,1.1-0.1,1.5c0,0.4-0.1,0.7-0.1,1c0,0.2,0,0.4,0,0.6c0,0.5,0.2,0.8,0.7,0.9
          c0.3,0.1,0.7,0.1,1,0.2c0.3,0,0.6,0.1,0.8,0.1c0.4,0,0.6-0.1,0.7-0.3c0.1-0.2,0.2-0.4,0.2-0.7c0.1-0.6,0.2-1.3,0.2-1.9
          c0.1-0.6,0.1-1.3,0.2-1.9c0-0.6,0.1-1.1,0.1-1.7c0-0.5,0-1,0-1.3C94.2,7.2,94.1,6.6,93.8,6.2z"
        />
        <path
          fill="#ffffff"
          d="M106.1,8.4c-0.2-0.6-0.5-1.1-0.9-1.6c-0.4-0.5-1-1-1.6-1.3c-0.7-0.4-1.5-0.5-2.5-0.5c-0.7,0-1.4,0.1-2.1,0.4
          c-0.7,0.3-1.3,0.7-1.8,1.1c-0.5,0.5-0.9,1.1-1.2,1.8c-0.3,0.7-0.5,1.4-0.5,2.2c0,0.8,0.2,1.6,0.5,2.2c0.3,0.7,0.7,1.2,1.2,1.7
          c0.5,0.5,1.1,0.8,1.7,1.1c0.7,0.3,1.3,0.4,2,0.4c1,0,1.9-0.1,2.6-0.4s1.4-0.6,1.8-1c0.2-0.2,0.3-0.5,0.3-0.7v-0.2
          c0-0.1,0-0.1,0-0.2c0-0.2-0.1-0.3-0.1-0.5c0-0.2-0.1-0.3-0.1-0.5c-0.1-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.1-0.1-0.3-0.1
          c-0.1,0-0.2,0-0.5,0.1c-0.4,0.2-0.9,0.4-1.4,0.5c-0.5,0.1-0.9,0.2-1.3,0.2c-0.5,0-1-0.1-1.4-0.3c-0.5-0.2-0.8-0.5-1.1-0.8
          c0.6,0,1.2-0.1,1.8-0.1c0.6-0.1,1.2-0.1,1.8-0.2c0.6-0.1,1.1-0.2,1.6-0.3c0.5-0.1,0.9-0.2,1.3-0.4c0.2-0.1,0.4-0.2,0.4-0.3
          c0.1-0.1,0.1-0.3,0.1-0.5C106.4,9.4,106.3,8.9,106.1,8.4z M100.9,9.3c-0.7,0.1-1.4,0.1-2,0.1C99,9,99.3,8.6,99.8,8.3
          c0.4-0.3,0.9-0.4,1.4-0.4c0.3,0,0.7,0.1,1,0.3c0.3,0.2,0.6,0.5,0.7,0.9C102.3,9.2,101.6,9.3,100.9,9.3z"
        />
        <path
          fill="#ffffff"
          d="M118.1,7.8c-0.1-0.2-0.3-0.3-0.4-0.5c-0.6-0.6-1.3-1-2.2-1.2c0-0.2,0-0.3,0.1-0.3c0-0.1,0-0.1,0-0.2
          c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.4-0.2c-0.3-0.1-0.5-0.1-0.8-0.2c-0.3,0-0.6-0.1-0.8-0.1c-0.7,0-1.5,0.1-2.2,0.4
          c-0.7,0.3-1.3,0.7-1.9,1.1c0,0,0,0,0,0c-0.6,0.5-1,1.1-1.4,1.8c-0.4,0.7-0.5,1.5-0.5,2.4c0,0.9,0.2,1.6,0.4,2.3
          c0.3,0.7,0.7,1.2,1.2,1.7c0.5,0.4,1.2,0.8,1.9,1c0.8,0.2,1.6,0.3,2.5,0.3c0.7,0,1.4-0.1,2-0.3c0.7-0.2,1.3-0.5,1.8-1
          c0.5-0.4,1-1,1.3-1.6c0.3-0.6,0.5-1.4,0.5-2.2C119,9.7,118.7,8.7,118.1,7.8z M115.4,11.6c-0.1,0.3-0.3,0.5-0.6,0.6
          c-0.2,0.2-0.5,0.3-0.8,0.4c-0.3,0.1-0.6,0.1-0.9,0.1c-0.3,0-0.6,0-0.9-0.1c-0.3-0.1-0.5-0.2-0.7-0.4c-0.2-0.2-0.4-0.4-0.5-0.6
          c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.8,0.2-1.4,0.7-1.9c0.5-0.5,1.1-0.8,1.8-0.9c0,0.2,0,0.4,0,0.5c0,0.1,0.1,0.2,0.2,0.3
          c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0.1,0.4,0.2c0.4,0.1,0.7,0.3,1,0.6c0.2,0.3,0.4,0.6,0.4,1C115.6,11.1,115.5,11.3,115.4,11.6z"
        />
        <path
          fill="#ffffff"
          d="M130.6,9.2c0-0.1,0-0.2,0-0.3c-0.1-1-0.2-2-0.2-3c-0.1-0.4-0.2-0.6-0.4-0.7C129.8,5,129.5,5,129.1,5
          c-0.2,0-0.4,0-0.7,0c-0.2,0-0.4,0.1-0.6,0.1c-0.4,0.1-0.7,0.2-0.9,0.4c-0.2,0.2-0.2,0.4-0.2,0.7c0,0.1,0,0.4,0.1,0.7
          c0,0.3,0.1,0.8,0.1,1.3c0,0.1,0,0.2,0,0.3c0,0.4,0.1,0.9,0.1,1.4c0,0.6,0.1,1.2,0.1,1.9c-0.4,0.3-0.8,0.5-1.2,0.6
          c-0.4,0.1-0.8,0.2-1.2,0.2c-0.3,0-0.5-0.1-0.6-0.3c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.6,0-1.1,0.1-1.7c0-0.6,0.1-1.1,0.1-1.6
          c0,0,0,0,0,0c0-0.5,0.1-0.9,0.1-1.2c0-0.4,0.1-0.6,0.1-0.8c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.1-0.3-0.2-0.5-0.3
          C123.2,5.1,123,5,122.8,5c-0.2,0-0.5,0-0.7,0c-0.5,0-0.8,0.1-1,0.2s-0.4,0.4-0.4,0.8c-0.1,0.6-0.2,1.1-0.2,1.7c0,0.1,0,0.1,0,0.2
          c-0.1,0.6-0.1,1.3-0.2,1.9c0,0.6-0.1,1.1-0.1,1.7c0,0.5,0,1,0,1.4c0,0.7,0.1,1.2,0.3,1.6c0.2,0.4,0.5,0.7,0.9,0.9
          c0.3,0.2,0.7,0.3,1.1,0.4c0.4,0.1,0.7,0.1,1,0.1c0.6,0,1.2-0.1,1.8-0.3c0.6-0.2,1.2-0.5,1.7-0.8c0,0.1,0,0.2,0,0.3
          c0,0.1,0,0.2,0,0.3c0,0.4,0.3,0.7,0.8,0.7c0.3,0,0.7,0,1.2-0.1c0.4-0.1,0.9-0.2,1.2-0.3c0.3-0.1,0.4-0.3,0.5-0.5
          c0.1-0.2,0.1-0.5,0.1-0.8c0-0.2,0-0.5,0-0.8v-0.8C130.7,11.5,130.7,10.3,130.6,9.2z"
        />
        <path
          fill="#ffffff"
          d="M137.5,8.5c0.1,0.1,0.3,0.2,0.6,0.2c0.4,0.1,0.9,0.1,1.3,0.1c0.3,0,0.5-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.3-0.5
          c0.1-0.3,0.1-0.6,0.2-1c0.1-0.4,0.1-0.7,0.1-1c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.2-0.3-0.3-0.5-0.3c-0.4-0.1-0.9-0.3-1.5-0.4
          c-0.5-0.1-1.1-0.1-1.6-0.1c-0.6,0-1.2,0.1-1.8,0.2c-0.6,0.2-1.1,0.4-1.5,0.7c-0.5,0.3-0.8,0.7-1.1,1.1s-0.4,0.9-0.4,1.4
          c0,0.4,0,0.7,0.1,0.9c0.1,0.2,0.1,0.3,0.2,0.4c0.2,0.4,0.5,0.7,0.8,1c0.3,0.3,0.7,0.5,1.1,0.7c0.4,0.2,0.7,0.3,1.1,0.5
          c0.3,0.1,0.6,0.3,0.8,0.4c0.2,0.1,0.3,0.3,0.3,0.4c0,0.2-0.1,0.3-0.3,0.4c-0.2,0.1-0.5,0.1-0.8,0.1c-0.2,0-0.5,0-0.8-0.1
          c-0.3-0.1-0.6-0.2-0.8-0.3c-0.3-0.1-0.5-0.2-0.6-0.2c-0.2,0-0.3,0.1-0.5,0.5c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2-0.2,0.5-0.2,0.7
          c0,0.2-0.1,0.3-0.1,0.5c0,0.3,0.2,0.6,0.6,0.7c0.4,0.2,0.9,0.3,1.4,0.4c0.5,0.1,1,0.1,1.6,0.1c0.7,0,1.3-0.1,1.9-0.2
          c0.1,0,0.2-0.1,0.3-0.1c0.4-0.1,0.8-0.3,1.2-0.5c0.4-0.3,0.8-0.6,1-1c0.2-0.4,0.4-0.8,0.4-1.3c0-0.2,0-0.5-0.1-0.6
          c-0.1-0.3-0.2-0.5-0.3-0.8c-0.2-0.4-0.6-0.7-0.9-1c-0.2-0.1-0.4-0.3-0.7-0.4c0,0,0,0,0,0c-0.2-0.1-0.3-0.2-0.5-0.3
          c-0.4-0.2-0.8-0.3-1.2-0.5c-0.4-0.1-0.7-0.3-0.9-0.4c-0.2-0.1-0.4-0.3-0.4-0.4c0-0.2,0.1-0.4,0.4-0.5c0.2-0.1,0.6-0.1,0.9-0.1
          c0.2,0,0.4,0,0.7,0.1v0.2C137.4,8.2,137.4,8.4,137.5,8.5z"
        />
      </g>
      {resources && (
        <g className="resources-wrap" transform="translate(65, 120)">
          <ResourceLink
            r={resources[0]}
            svgComponent={resource1SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[0], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[1]}
            svgComponent={resource2SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[1], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[2]}
            svgComponent={resource3SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[2], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[3]}
            svgComponent={resource4SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[3], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[4]}
            svgComponent={resource5SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[4], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[5]}
            svgComponent={resource6SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[5], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
        </g>
      )}
    </g>
  );
};
export default MiscellaneousLink;
